"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _tag = require("@citrus/tag");
var _dragNDrop = require("@citrus/drag-n-drop");
var _lodash = _interopRequireDefault(require("lodash.findindex"));
var _uuid = _interopRequireDefault(require("uuid"));
var _questionBuilder = require("@pcty/question-builder");
var _PctyQuestionBuilderEdit = _interopRequireDefault(require("./PctyQuestionBuilder.Edit.QuestionOptions"));
var _PctyQuestionBuilder = require("./PctyQuestionBuilder.Constants");
var _PctyQuestionBuilder2 = require("./PctyQuestionBuilder.Common");
var Presentational = function Presentational(_ref) {
  var id = _ref.id,
    scenario = _ref.scenario,
    question = _ref.question,
    options = _ref.options,
    optionsCorrectOrder = _ref.optionsCorrectOrder,
    knockout = _ref.knockout,
    knockoutText = _ref.knockoutText,
    hint = _ref.hint,
    builderType = _ref.builderType,
    number = _ref.number,
    required = _ref.required,
    editable = _ref.editable,
    onQuestionUpdated = _ref.onQuestionUpdated;
  var questionTypeId = _questionBuilder.QUESTION_TYPE.stackRank;
  var onQuestionTextUpdated = function onQuestionTextUpdated(questionText) {
    if (onQuestionUpdated) onQuestionUpdated({
      questionText: questionText
    });
  };
  var onOptionsUpdated = function onOptionsUpdated(edit) {
    var options = edit ? edit.options : [];
    if (onQuestionUpdated) onQuestionUpdated({
      options: options
    });
  };

  // setup our dummy edit container for the options' inline-editing
  var edit = {
    options: options,
    typeId: questionTypeId
  };
  var validationState = (0, _PctyQuestionBuilder2.validate)(edit, true, builderType);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _PctyQuestionBuilder2.renderHint)(id, hint), (0, _PctyQuestionBuilder2.renderScenario)(id, scenario), (0, _PctyQuestionBuilder2.renderQuestion)(id, questionTypeId, number, question, required, editable, onQuestionTextUpdated), (0, _PctyQuestionBuilder2.renderKnockout)(id, knockout, knockoutText), editable ? /*#__PURE__*/_react.default.createElement(_PctyQuestionBuilderEdit.default, {
    id: id,
    builderType: builderType,
    edit: edit,
    validationState: validationState,
    onOptionsChange: onOptionsUpdated
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "pcty-col-xs-12"
  }, options.map(function (x, item) {
    return /*#__PURE__*/_react.default.createElement(_dragNDrop.DragNDrop.DroppedItem, {
      disabled: true,
      id: "".concat(id, "-").concat(item),
      key: "".concat(id, "-").concat(x.id)
    }, renderDroppedItem(builderType, optionsCorrectOrder, x));
  }))));
};
var renderDroppedItem = function renderDroppedItem(builderType, optionsCorrectOrder, item) {
  if (builderType === _PctyQuestionBuilder.BUILDER_TYPE.survey) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      className: "pcty-qb-stackrank-disabled-active"
    }, " ", item.value));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "pcty-qb-stackrank-disabled-active"
  }, " ", item.value), " ", /*#__PURE__*/_react.default.createElement(_tag.Tag, {
    key: _uuid.default.v4(),
    type: "positive",
    value: (0, _lodash.default)(optionsCorrectOrder, function (z) {
      return z.optionId === item.id;
    }) + 1
  }));
};
var _default = exports.default = Presentational;